// extracted by mini-css-extract-plugin
export default {"menuWrapper":"menu_menuWrapper_zdgpA","open":"menu_open_tpYx8","menu":"menu_menu_vLuEH","mobileIcon":"menu_mobileIcon_rKEp5","item":"menu_item_4hDlV","link":"menu_link_WFqdQ"};